import { render, staticRenderFns } from "./getStamp.vue?vue&type=template&id=1683fd57&scoped=true"
import script from "./getStamp.vue?vue&type=script&lang=js"
export * from "./getStamp.vue?vue&type=script&lang=js"
import style0 from "./getStamp.vue?vue&type=style&index=0&id=1683fd57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1683fd57",
  null
  
)

export default component.exports